import { render } from "./ShutterActuator.vue?vue&type=template&id=3d2a8372&ts=true"
import script from "./ShutterActuator.vue?vue&type=script&lang=ts"
export * from "./ShutterActuator.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__